interface AttachmentIconProps {
  onClick?: () => void;
}

export default function AttachmentIcon({ onClick }: AttachmentIconProps) {
  return <a className="bi bi-paperclip attachment-icon" onClick={onClick}></a>;
}
